import {actionIds, BaseAction} from "../common";

const connectedAction: () =>
    BaseAction = () => ({
    type: actionIds.CONNECTED,
    payload: {},
});

export default connectedAction;
